import React from "react";

export default function ImagesTile({ model, title }) {
  return (
    <React.Fragment>
      <div className="title">{title}</div>
      <div className="images tile-content">{model.count}</div>
    </React.Fragment>
  );
}
